import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Row, Col, Modal, Button, ProgressBar } from "react-bootstrap";
import { minutesToHourAndMinutes } from "../helpers/HelperFunctions";

const renderStatus = (status) => {
	switch (status) {
	case "to_do":
		return <div className="text-center"><span className="status status-to-do">To do</span></div>;
	case "done":
		return <div className="text-center"><span className="status status-done">Done</span></div>;
	case "in_progess":
		return <div className="text-center"><span className="status status-in-progress">In Progress</span></div>;
	default:
		return <div className="text-center"><span className="status status-default">{status}</span></div>;
	}
};

const renderProgress = (status, completed) => {
	if (status && completed >= 0) {
		let styleClass = "info";
		if (completed > 100) {
			styleClass = "danger";
		}
		else if (status == 3 && completed <= 100) {  // eslint-disable-line
			styleClass = "success";
		}
		return <ProgressBar bsStyle={styleClass} now={completed > 100 ? 100 : completed} label={`${completed}%`} />;
	}
	return "No progress!";
};


const TaskDetailsModal = (props) => {
	const timeSpent = minutesToHourAndMinutes(props.selectedTask.time_spent);
	const estimated = minutesToHourAndMinutes(props.selectedTask.estimated);
	return (
		<Modal className="task-details-modal" show={props.showTaskDetailsModal} onHide={props.handleClose}>
			<Modal.Header>
				<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={props.handleClose}>&times;</button>
				<Modal.Title>{props.selectedTask.name}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Name:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{props.selectedTask.name}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Project:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{props.selectedTask.project_name}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Status:</h4> </Col>
					<Col md={9} sm={8} xs={12}> {renderStatus(props.selectedTask.status_name)} </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Progress:</h4> </Col>
					<Col md={9} sm={8} xs={12}>{renderProgress(props.selectedTask.status_id, props.selectedTask.progress)}</Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Estimated:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{estimated.hours > 0 ? `${estimated.hours}h` : `${0}h`} {estimated.minutes > 0 ? ` and ${estimated.minutes}min` : null}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Time spent:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{timeSpent.hours > 0 ? `${timeSpent.hours}h` : `${0}h`} {timeSpent.minutes > 0 ? ` and ${timeSpent.minutes}min` : null}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Assigned to:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{props.selectedTask.assigned_to_name}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Created by:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{props.selectedTask.creator_name}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Created date:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5>{moment(props.selectedTask.created_at).format("DD-MM-YYYY")}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={4} xs={12}> <h4>Description:</h4> </Col>
					<Col md={9} sm={8} xs={12}> <h5 className="details-description">{props.selectedTask.description}</h5> </Col>
				</Row>

			</Modal.Body>
			<Modal.Footer>
				<Button bsStyle="default" className="btn-min" onClick={props.handleClose}>Close</Button>
			</Modal.Footer>
		</Modal>
	);
};

TaskDetailsModal.defaultProps = {
	selectedTask: PropTypes.shape({
		name: "",
		project_name: "",
		status_name: "",
		status_id: "",
		progress: "",
		estimated: "",
		time_spent: "",
		assigned_to_name: "",
		creator_name: "",
		created_at: "",
		description: ""
	})
};

TaskDetailsModal.propTypes = {
	showTaskDetailsModal: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	selectedTask: PropTypes.shape({
		name: PropTypes.string,
		project_name: PropTypes.string,
		status_name: PropTypes.string,
		status_id: PropTypes.number,
		progress: PropTypes.number,
		estimated: PropTypes.number,
		time_spent: PropTypes.string,
		assigned_to_name: PropTypes.string,
		creator_name: PropTypes.string,
		created_at: PropTypes.string,
		description: PropTypes.string
	})
};

export default TaskDetailsModal;



// WEBPACK FOOTER //
// ./src/components/modals/TaskDetailsModal.js